import Transformer from './transformer';
import providerTransformer from './providerProfile';
import patientTransformer from './patientProfile';
import couponTransformer from './coupon';
import dateTimeUtils from '../utils/dateTime';
export default class AppointmentTransformer extends Transformer {
  static fetch(appointment) {
    return {
      id: appointment.id,
      hashid: appointment.hashid,
      patient_profile: patientTransformer.fetch(
        // appointment.patient_profile.data
        appointment.patient_profile
      ),
      provider_profile: providerTransformer.fetch(
        // appointment.provider_profile.data
        appointment.provider_profile
      ),
      status: appointment.status,
      call_channel: appointment.call_channel,
      type: appointment.type,
      reserved_duration: appointment.reserved_duration,
      extension_duration: appointment.extension_duration,
      duration_string: appointment.duration_string,
      duration: appointment.duration,
      draft: appointment.draft,
      cancel_reason: appointment.cancel_reason,
      cancel_by: appointment.cancel_by,
      cancel_at: appointment.cancel_at,
      net_price: appointment.net_price,
      price_rate: appointment.price_rate,
      price_detail: appointment.price_detail,
      start: appointment.start,
      end: appointment.end,
      wait: appointment.wait,
      last_wait: appointment.last_wait,
      provider_last_wait: appointment.provider_last_wait,
      provider_wait: appointment.provider_wait,
      transaction: appointment.transaction,
      patient_last_wait: appointment.last_wait,
      coupon: appointment.coupon_id ? couponTransformer.fetch(appointment.coupon.data) : null,
      appointed_at: appointment.appointed_at,
      due: appointment.due,
      created: appointment.created,
      created_at: appointment.created_at,
      organization: appointment.organization,
      new_coupon: appointment.new_coupon_usage_history ? appointment.new_coupon_usage_history.new_coupon : null,
      channel: appointment.channel,
      location: appointment.location,
    };
  }

  static changeDueDate(payload) {
    payload.due = dateTimeUtils.revertFormatDateTimeForPayload(payload.due);
    payload.due = dateTimeUtils.formatDateTimeForPayload(payload.due);
    console.log(payload);
    return payload;
  }

  static changeStatus(payload) {
    payload.status = payload.status.value;
    return payload;
  }
}
